// extracted by mini-css-extract-plugin
export default {"guide-order-sim":"Info_guide-order-sim__W5Zpo"};